import React, { useState, useRef, useEffect } from 'react';
import { 
  Form, 
  Input, 
  Button, 
  Card, 
  message, 
  Select, 
  Upload, 
  Space
} from 'antd';
import { 
  UserOutlined, 
  LockOutlined, 
  MailOutlined, 
  PhoneOutlined, 
  BankOutlined,
  EnvironmentOutlined,
  UploadOutlined
} from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import axios from '../../utils/axios';

const { Option } = Select;
const { TextArea } = Input;

// Country list
const countries = [
  { code: 'AF', name: 'Afghanistan', currency: 'AFN' },
  { code: 'AL', name: 'Albania', currency: 'ALL' },
  { code: 'DZ', name: 'Algeria', currency: 'DZD' },
  { code: 'AR', name: 'Argentina', currency: 'ARS' },
  { code: 'AU', name: 'Australia', currency: 'AUD' },
  { code: 'AT', name: 'Austria', currency: 'EUR' },
  { code: 'BH', name: 'Bahrain', currency: 'BHD' },
  { code: 'BD', name: 'Bangladesh', currency: 'BDT' },
  { code: 'BE', name: 'Belgium', currency: 'EUR' },
  { code: 'BR', name: 'Brazil', currency: 'BRL' },
  { code: 'BG', name: 'Bulgaria', currency: 'BGN' },
  { code: 'KH', name: 'Cambodia', currency: 'KHR' },
  { code: 'CA', name: 'Canada', currency: 'CAD' },
  { code: 'CL', name: 'Chile', currency: 'CLP' },
  { code: 'CN', name: 'China', currency: 'CNY' },
  { code: 'CO', name: 'Colombia', currency: 'COP' },
  { code: 'HR', name: 'Croatia', currency: 'HRK' },
  { code: 'CY', name: 'Cyprus', currency: 'EUR' },
  { code: 'CZ', name: 'Czech Republic', currency: 'CZK' },
  { code: 'DK', name: 'Denmark', currency: 'DKK' },
  { code: 'EG', name: 'Egypt', currency: 'EGP' },
  { code: 'EE', name: 'Estonia', currency: 'EUR' },
  { code: 'FI', name: 'Finland', currency: 'EUR' },
  { code: 'FR', name: 'France', currency: 'EUR' },
  { code: 'DE', name: 'Germany', currency: 'EUR' },
  { code: 'GR', name: 'Greece', currency: 'EUR' },
  { code: 'HK', name: 'Hong Kong', currency: 'HKD' },
  { code: 'HU', name: 'Hungary', currency: 'HUF' },
  { code: 'IS', name: 'Iceland', currency: 'ISK' },
  { code: 'IN', name: 'India', currency: 'INR' },
  { code: 'ID', name: 'Indonesia', currency: 'IDR' },
  { code: 'IR', name: 'Iran', currency: 'IRR' },
  { code: 'IQ', name: 'Iraq', currency: 'IQD' },
  { code: 'IE', name: 'Ireland', currency: 'EUR' },
  { code: 'IL', name: 'Israel', currency: 'ILS' },
  { code: 'IT', name: 'Italy', currency: 'EUR' },
  { code: 'JP', name: 'Japan', currency: 'JPY' },
  { code: 'JO', name: 'Jordan', currency: 'JOD' },
  { code: 'KZ', name: 'Kazakhstan', currency: 'KZT' },
  { code: 'KE', name: 'Kenya', currency: 'KES' },
  { code: 'KR', name: 'South Korea', currency: 'KRW' },
  { code: 'KW', name: 'Kuwait', currency: 'KWD' },
  { code: 'LV', name: 'Latvia', currency: 'EUR' },
  { code: 'LB', name: 'Lebanon', currency: 'LBP' },
  { code: 'LT', name: 'Lithuania', currency: 'EUR' },
  { code: 'LU', name: 'Luxembourg', currency: 'EUR' },
  { code: 'MO', name: 'Macao', currency: 'MOP' },
  { code: 'MY', name: 'Malaysia', currency: 'MYR' },
  { code: 'MV', name: 'Maldives', currency: 'MVR' },
  { code: 'MT', name: 'Malta', currency: 'EUR' },
  { code: 'MX', name: 'Mexico', currency: 'MXN' },
  { code: 'MA', name: 'Morocco', currency: 'MAD' },
  { code: 'NL', name: 'Netherlands', currency: 'EUR' },
  { code: 'NZ', name: 'New Zealand', currency: 'NZD' },
  { code: 'NG', name: 'Nigeria', currency: 'NGN' },
  { code: 'NO', name: 'Norway', currency: 'NOK' },
  { code: 'OM', name: 'Oman', currency: 'OMR' },
  { code: 'PK', name: 'Pakistan', currency: 'PKR' },
  { code: 'PA', name: 'Panama', currency: 'PAB' },
  { code: 'PG', name: 'Papua New Guinea', currency: 'PGK' },
  { code: 'PY', name: 'Paraguay', currency: 'PYG' },
  { code: 'PE', name: 'Peru', currency: 'PEN' },
  { code: 'PH', name: 'Philippines', currency: 'PHP' },
  { code: 'PL', name: 'Poland', currency: 'PLN' },
  { code: 'PT', name: 'Portugal', currency: 'EUR' },
  { code: 'QA', name: 'Qatar', currency: 'QAR' },
  { code: 'RO', name: 'Romania', currency: 'RON' },
  { code: 'RU', name: 'Russia', currency: 'RUB' },
  { code: 'SA', name: 'Saudi Arabia', currency: 'SAR' },
  { code: 'SG', name: 'Singapore', currency: 'SGD' },
  { code: 'SK', name: 'Slovakia', currency: 'EUR' },
  { code: 'SI', name: 'Slovenia', currency: 'EUR' },
  { code: 'ZA', name: 'South Africa', currency: 'ZAR' },
  { code: 'ES', name: 'Spain', currency: 'EUR' },
  { code: 'LK', name: 'Sri Lanka', currency: 'LKR' },
  { code: 'SE', name: 'Sweden', currency: 'SEK' },
  { code: 'CH', name: 'Switzerland', currency: 'CHF' },
  { code: 'TW', name: 'Taiwan', currency: 'TWD' },
  { code: 'TH', name: 'Thailand', currency: 'THB' },
  { code: 'TR', name: 'Turkey', currency: 'TRY' },
  { code: 'AE', name: 'United Arab Emirates', currency: 'AED' },
  { code: 'GB', name: 'United Kingdom', currency: 'GBP' },
  { code: 'US', name: 'United States', currency: 'USD' },
  { code: 'VN', name: 'Vietnam', currency: 'VND' },
];

// Get all unique currencies
const uniqueCurrencies = Array.from(new Set(countries.map(country => country.currency)))
  .sort()
  .map(code => {
    const currencyNames = {
      USD: 'US Dollar',
      EUR: 'Euro',
      GBP: 'British Pound',
      JPY: 'Japanese Yen',
      CNY: 'Chinese Yuan',
      AUD: 'Australian Dollar',
      CAD: 'Canadian Dollar',
      CHF: 'Swiss Franc',
      HKD: 'Hong Kong Dollar',
      SGD: 'Singapore Dollar',
      SEK: 'Swedish Krona',
      KRW: 'South Korean Won',
      TWD: 'New Taiwan Dollar',
      AED: 'UAE Dirham',
      INR: 'Indian Rupee',
      // Add display names for other currencies...
    };
    return {
      code,
      name: currencyNames[code] ? `${currencyNames[code]} (${code})` : code
    };
  });

const Register = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [, setSelectedCountry] = useState(null);
  const [fileList, setFileList] = useState([]);
  
  // Email verification code state
  const [emailVerified, setEmailVerified] = useState(false);
  const [verificationCodeSent, setVerificationCodeSent] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [sendingCode, setSendingCode] = useState(false);
  const [verifyingCode, setVerifyingCode] = useState(false);
  // Hold the active countdown interval id in a ref so it survives re-renders
  // and can be cleared on unmount — without this, navigating away from the
  // register page mid-countdown leaves a 1Hz `setState` ticking against an
  // unmounted component.
  const countdownTimerRef = useRef(null);
  useEffect(() => {
    return () => {
      if (countdownTimerRef.current) {
        clearInterval(countdownTimerRef.current);
        countdownTimerRef.current = null;
      }
    };
  }, []);

  const handleCountryChange = (value) => {
    setSelectedCountry(value);
    // Auto-set corresponding currency
    const country = countries.find(c => c.code === value);
    if (country) {
      form.setFieldsValue({ currency: country.currency });
    }
  };

  const beforeUpload = (file) => {
    const isValidType = file.type === 'application/pdf' || file.type.startsWith('image/');
    if (!isValidType) {
      message.error('You can only upload PDF or image files!');
      return false;
    }
    // Remove file size limit
    // Return false to prevent automatic upload, we'll handle it manually
    return false;
  };

  const handleFileChange = ({ fileList }) => {
    // Keep only the latest file
    const latestFile = fileList.slice(-1);
    // Update UI
    setFileList(latestFile);
  };

  const registerMutation = useMutation(
    async (values) => {
      
      const formData = new FormData();
      // Add all form fields to FormData
      Object.keys(values).forEach(key => {
        if (key !== 'businessLicense' && values[key] !== undefined) {
          formData.append(key, values[key]);
        }
      });
      
      // Add file if present
      if (fileList[0]?.originFileObj) {
        formData.append('businessLicense', fileList[0].originFileObj);
      } else {
      }

      const response = await axios.post('/auth/register', formData);
      return response.data;
    },
    {
      onSuccess: (data) => {
        message.success({
          content: 'Registration successful! Please check your email for confirmation. We will review your application within 1-2 business days.',
          duration: 8
        });
        navigate('/login');
      },
      onError: (error) => {
        console.error('Registration error:', error);
        console.error('Error response:', error.response);
        console.error('Error status:', error.response?.status);
        console.error('Error data:', error.response?.data);
        
        const errorMessage = error.response?.data?.message || 'Registration failed';
        message.error(errorMessage);
      }
    }
  );

  // Send email verification code
  const sendVerificationCode = async () => {
    const email = form.getFieldValue('email');
    
    if (!email) {
      message.error('Please enter your email address first');
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      message.error('Please enter a valid email address');
      return;
    }

    try {
      setSendingCode(true);
      await axios.post('/auth/send-verification-code', { email });
      
      message.success('Verification code sent to your email');
      setVerificationCodeSent(true);
      setCountdown(300); // 5 min countdown

      // Replace any prior countdown so a re-send doesn't stack timers.
      if (countdownTimerRef.current) {
        clearInterval(countdownTimerRef.current);
      }
      countdownTimerRef.current = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            if (countdownTimerRef.current) {
              clearInterval(countdownTimerRef.current);
              countdownTimerRef.current = null;
            }
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      
    } catch (error) {
      console.error('Send verification code error:', error);
      const errorMessage = error.response?.data?.message || 'Failed to send verification code';
      message.error(errorMessage);
    } finally {
      setSendingCode(false);
    }
  };

  // Verify email code
  const verifyEmailCode = async () => {
    const email = form.getFieldValue('email');
    const code = form.getFieldValue('verificationCode');
    
    if (!email || !code) {
      message.error('Please enter email and verification code');
      return;
    }

    try {
      setVerifyingCode(true);
      await axios.post('/auth/verify-code', { email, code });
      
      message.success('Email verified successfully!');
      setEmailVerified(true);
      form.setFieldsValue({ emailVerified: true });
      
    } catch (error) {
      console.error('Verify code error:', error);
      const errorMessage = error.response?.data?.message || 'Invalid verification code';
      message.error(errorMessage);
    } finally {
      setVerifyingCode(false);
    }
  };

  const handleSubmit = (values) => {
    
    if (!emailVerified) {
      message.error('Please verify your email address first');
      return;
    }
    
    if (fileList.length === 0) {
      message.error('Please upload your business license or registration certificate');
      return;
    }
    
    registerMutation.mutate(values);
  };

  return (
    <Card className="login-form" style={{ maxWidth: 600 }}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        {/* Logo */}
        <img
          src="/images/vouchain-logo.png"
          alt="Vouchain Logo"
          style={{ height: 48, marginBottom: 12 }}
        />
        <h1 className="login-title" style={{ margin: '2px 0', fontSize: '24px', fontWeight: 800 }}>Create Account</h1>
        <p className="login-subtitle" style={{ margin: 0, fontSize: '14px', color: '#666' }}>Register your business with us</p>
      </div>

      <Form
        form={form}
        name="register"
        onFinish={handleSubmit}
        layout="vertical"
        size="large"
        scrollToFirstError
      >
        <Form.Item
          name="firstName"
          label="First Name"
          rules={[{ required: true, message: 'Please input your first name!' }]}
        >
          <Input
            prefix={<UserOutlined />}
            placeholder="Enter your first name"
          />
        </Form.Item>

        <Form.Item
          name="lastName"
          label="Last Name"
          rules={[{ required: true, message: 'Please input your last name!' }]}
        >
          <Input
            prefix={<UserOutlined />}
            placeholder="Enter your last name"
          />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email!' }
          ]}
        >
          <div style={{ display: 'flex', gap: '8px' }}>
            <Input
              style={{ flex: 1 }}
              prefix={<MailOutlined />}
              placeholder="Enter your email"
              autoComplete="email"
              disabled={emailVerified}
            />
            <Button
              type="primary"
              onClick={sendVerificationCode}
              disabled={sendingCode || countdown > 0 || emailVerified}
              loading={sendingCode}
              style={{ 
                minWidth: '100px',
                borderRadius: '6px',
                fontWeight: '500'
              }}
            >
              {countdown > 0 ? `${Math.floor(countdown / 60)}:${(countdown % 60).toString().padStart(2, '0')}` : 'Send Code'}
            </Button>
          </div>
        </Form.Item>

        {verificationCodeSent && !emailVerified && (
          <Form.Item
            name="verificationCode"
            label="Email Verification Code"
            rules={[
              { required: true, message: 'Please input the verification code!' },
              { len: 6, message: 'Verification code must be 6 digits!' }
            ]}
          >
            <div style={{ display: 'flex', gap: '8px' }}>
              <Input
                style={{ flex: 1 }}
                placeholder="Enter 6-digit code"
                maxLength={6}
              />
              <Button
                type="primary"
                onClick={verifyEmailCode}
                loading={verifyingCode}
                style={{ 
                  minWidth: '80px',
                  borderRadius: '6px',
                  fontWeight: '500'
                }}
              >
                Verify
              </Button>
            </div>
          </Form.Item>
        )}

        {emailVerified && (
          <Form.Item>
            <div style={{ 
              padding: '8px 12px', 
              backgroundColor: '#f6ffed', 
              border: '1px solid #b7eb8f',
              borderRadius: '6px',
              color: '#52c41a'
            }}>
              ✓ Email verified successfully
            </div>
          </Form.Item>
        )}

        <Form.Item
          name="companyName"
          label="Company Name"
          rules={[{ required: true, message: 'Please input your company name!' }]}
        >
          <Input
            prefix={<BankOutlined />}
            placeholder="Enter your company name"
          />
        </Form.Item>

        <Form.Item
          name="country"
          label="Company Country"
          rules={[{ required: true, message: 'Please select your company country!' }]}
        >
          <Select
            showSearch
            placeholder="Select your company country"
            onChange={handleCountryChange}
            filterOption={(input, option) => {
              const countryName = option?.label?.toLowerCase() || '';
              const countryCode = option?.value?.toLowerCase() || '';
              const searchText = input.toLowerCase();
              return countryName.includes(searchText) || countryCode.includes(searchText);
            }}
            listHeight={320}
            style={{ width: '100%' }}
            optionLabelProp="label"
            defaultActiveFirstOption={false}
            showArrow={true}
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
            }
          >
            {countries.map(country => (
              <Option 
                key={country.code} 
                value={country.code}
                label={country.name}
              >
                <Space>
                  <img
                    src={`/flags/${country.code.toLowerCase()}.png`}
                    alt={country.name}
                    style={{ 
                      width: '24px', 
                      height: '18px', 
                      objectFit: 'cover',
                      verticalAlign: 'middle'
                    }}
                  />
                  {country.name}
                </Space>
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="currency"
          label="Settlement Currency"
          rules={[{ required: true, message: 'Please select your settlement currency!' }]}
        >
          <Select
            showSearch
            placeholder="Select your settlement currency"
            filterOption={(input, option) => {
              const currencyName = option?.children?.toLowerCase() || '';
              const currencyCode = option?.value?.toLowerCase() || '';
              const searchText = input.toLowerCase();
              return currencyName.includes(searchText) || currencyCode.includes(searchText);
            }}
            listHeight={320}
            style={{ width: '100%' }}
            defaultActiveFirstOption={false}
            showArrow={true}
          >
            {uniqueCurrencies.map(currency => (
              <Option key={currency.code} value={currency.code}>
                {currency.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="address"
          label="Company Address"
          rules={[{ required: true, message: 'Please input your company address!' }]}
        >
          <Input
            prefix={<EnvironmentOutlined />}
            placeholder="Enter your company address"
          />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Phone Number"
          rules={[{ required: true, message: 'Please input your phone number!' }]}
        >
          <Input
            prefix={<PhoneOutlined />}
            placeholder="Enter your phone number"
          />
        </Form.Item>

        <Form.Item
          name="businessLicense"
          label="Business License / Registration Certificate"
          rules={[{ required: true, message: 'Please upload your business license!' }]}
          extra="Support PDF or image files"
        >
          <Upload
            beforeUpload={beforeUpload}
            onChange={handleFileChange}
            fileList={fileList}
            maxCount={1}
            action=""
            showUploadList={{
              showPreviewIcon: true,
              showRemoveIcon: true,
            }}
          >
            <Button icon={<UploadOutlined />}>Click to Upload</Button>
          </Upload>
        </Form.Item>

        <Form.Item
          name="notes"
          label="Additional Notes"
          extra="Optional: Add information about legal representative, website, or other details"
        >
          <TextArea
            rows={4}
            placeholder="Enter additional information here..."
          />
        </Form.Item>

        <Form.Item
          name="password"
          label="Password"
          rules={[
            { required: true, message: 'Please input your password!' },
            { min: 6, message: 'Password must be at least 6 characters!' }
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Enter your password"
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirm Password"
          dependencies={['password']}
          rules={[
            { required: true, message: 'Please confirm your password!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Passwords do not match!'));
              },
            }),
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Confirm your password"
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={registerMutation.isLoading}
            disabled={!emailVerified}
          >
            {emailVerified ? 'Register' : 'Please verify email first'}
          </Button>
        </Form.Item>
      </Form>

      <div style={{ textAlign: 'center', marginTop: 16 }}>
        <span style={{ color: '#666' }}>Already have an account? </span>
        <Link to="/login">Sign in here</Link>
      </div>
    </Card>
  );
};

export default Register;
